import React, { useEffect, useState } from "react";
import { Row, Col, Button, Input } from "reactstrap";
import { Page, Sidebar } from "../../core";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ReactGA from "react-ga4";

import {
  getRefCode,
  getObUserState,
  getUserPans,
  getUploadedDocsList,
  getThirdPartyData,
  getUserEmailApi,
  getReferralListApi,
} from "../services/waitlist-service";
import PreviewModal from '../../shell/components/onboarding/PreviewModal';
import AddressPreview from "../../waitlistDocVault/components/AddressPreview";
import { flatten, get } from "lodash";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import { utils } from "../../core/helpers/utils";

const addressDocType = [
  'aadhaar', 
  'voterId', 
  'passport', 
  "address",
  "address_1",
  "aadhar",
  "pan",
  "poi"
];

const docList = [
  {
    type: 'pan',
    title: 'PAN',
    successText: 'PAN verified successfully',
    failureText: 'PAN verification failed',
    pendingText: 'PAN verification under process',
    notUploaded: 'Pan Verification Pending'
  },
  {
    type: 'address',
    title: 'KYC',
    successText: 'KYC verified successfully',
    failureText: 'KYC verification failed',
    pendingText: 'KYC verification under process',
    notUploaded: 'KYC Verification Pending'
  },
  {
    type: 'bank',
    title: 'Bank Account',
    successText: 'Bank account verified successfully',
    failureText: 'Bank account verification failed',
    pendingText: 'Bank account verification under process',
    notUploaded: 'Bank Verification Pending'
  },  
  {
    type: 'demat',
    title: 'Demat Account',
    successText: 'Demat account verified successfully',
    failureText: 'Demat account verification failed',
    pendingText: 'Demat account verification under process',
    notUploaded: 'Demat Verification Pending'
  }
]

export default function NaviLanding() {
  const [thirdPartyData, setThirdPartyData] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [userReferrals, setUserReferrals] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [refCode, setRefCode] = useState(null);
  const [previewData, setPreViewData] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [addressFiles, setAddressFile] = useState([]);
  const [isAddress, setIsAddress] = useState(false);
  const [isKycDone, setIsKycDone] = useState(false);
  const [errors, setErrors] = useState();
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const history = useHistory();
  const [isPdf, setIsPdf] = useState(false);
  const [product, setProduct] = useState();
  const params = useParams();
  const [isNativeView, setNativeView] = useState(false);
  const [accessToken, setAccessToken] = useState()
  const [userToken, setUserToken] = useState()
  const [transactionId, setTransactionId] = useState()
  const [workFlow, setWorkFlow] = useState()

  const toggleAddress = () => {
    setIsAddress(!isAddress);
  }

  const getUpdatedThirdPartyData = (productName) => {
    getThirdPartyData({"X-product": 'orobonds:default', 'x-encrypted-data': true})
      .then((result) => {
        const response = utils.parsePayload(result);
        if (response && response.success && response.data) {
          setThirdPartyData(response.data);
          let email = response.data.email;
          let pan = response.data.pan;
          getObUserState({email, pan}, productName,
            {"X-product": 'orobonds:default'}).then(
            (result) => {
              const resp = utils.parsePayload(result);
              if (resp && resp.success && resp.results) {
                setIsKycDone(resp.results.obUserApproved);
              }
            }
          );
          getUploadedDocsList(
            { payload: utils.encryptedPayload(get(response.data, "pan", "")) },
          {"X-product": 'orobonds:default'}).then((result) => {
            const docsList = utils.parsePayload(result);
            if (docsList && docsList.success) {
              setUploadedDocs(get(docsList, "data", []));        
            }
          });
        }
      });
  };

  const getUserDetails = (productName) => {
    getUserEmailApi({ "X-product": 'orobonds:default' })
      .then((result) => {
        const response = utils.parsePayload(result);

        if (response && response.success) {
          setUserDetails(response);
        }
      });
  };

  const getUserReferrals = (productName) => {
    getReferralListApi({"X-product": 'orobonds:default'})
      .then((response) => {
        if (response && response.success && response.data) {
          setUserReferrals(response.data.referrals);
        }
      });
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
  };

  useEffect(() => {
    if (window.ReactNativeWebView) {
      setNativeView(true);
    }
    setProduct(params.product);
    setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    getUserPans({"X-product": 'orobonds:default'}).then(
      (res) => {
        const panResp = utils.parsePayload(res);
        if (panResp && panResp.success) {
          setErrors(
            [...flatten(
              get(panResp, "data", []).map((p) =>
                p.rejectRemarks ? p.rejectRemarks : []
              )
            )]
          );
        }
      }
    )
    getUpdatedThirdPartyData(params.product);
    getUserDetails(params.product);
    getUserReferrals(params.product);
    getRefCode(params.product).then((response) => {
      if (response && response.success) {
        if (response.data) {
          setRefCode(response.data);
        }
      } else {
        toast.error("Something went wrong while fetching Refer code!");
      }
    });
  }, []);

  useEffect(()=>{
    const locationHash = window.location.hash;
      ReactGA.send({ hitType: 'pageview', page_location: `${locationHash}` });
      { process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent(locationHash, `${locationHash}`);
      }
},[])

  const isDocPresent = (docType) => {
    switch (docType) {
      case 'poi':
      case 'pan':
        return get(thirdPartyData, "pan", "") && get(thirdPartyData, "dob", "") &&
        get(thirdPartyData, "income", "") && get(thirdPartyData, "gender", "");
      case 'demat':
        return get(thirdPartyData, "demat", "");
      case 'address':
        if (get(thirdPartyData, "addressDocType", "") &&
        get(thirdPartyData, "addressDetails", "")) {
          return true;
        }
        return false;
      case 'bank':
        if ((get(thirdPartyData, "bankVerified.status", "") === 'verified' ) ||
        (get(thirdPartyData, "bankVerified.status", "") === 
        'verification under process')) {
          return true;
        }
        return false; 
    }
  };

  const redirectToDocvault = () => {
    history.push({
      pathname: '/biddeasy-docvault'
    });
  }

  const getDocsStateCard = () => {
    return docList.map((item, index) => {
      let status = '';
      if (isKycDone) {
        status = 'verified';
      } else if (isDocPresent(item.type)) {
        if (item.type === 'pan') {
          status = 'pending';
        } else if (item.type === 'bank' || item.type === 'demat') {
          if (errors && errors.find(e => e.type === item.type)) {
            status = 'failed';
          } else {
            status = 'pending';
          }
        } else {
          if (errors && errors.find(e => addressDocType.includes(e.type))) {
            status = 'failed';
          } else {
            status = 'pending';
          }
        }
      } else {
        status = 'notUploaded';
      }
      
      return (
        <Col lg={5} className={isMobile ? "mb-3" : "mb-5"} style={isMobile ? {margin: '0rem'} : {}}>
          <div className="d-flex flex-row align-items-center mr-auto">
            {status === 'verified' ? (
              <>
                <img
                  src={process.env.REACT_APP_IMAGES_PATH + "success.webp"}
                  className="success-img"
                  alt="success img"
                />
                <div className="ml-4">
                  <p className="title font-weight-semi-bold">{item.title}</p>
                  <p className="subtext">{item.successText}</p>
                </div>
              </>
            ) : 
            (status === 'notUploaded') ? (
              <>
              <img
                src={process.env.REACT_APP_IMAGES_PATH + "pending.webp"}
                className="success-img"
                alt="failure img"
              />
              <div className="ml-4">
                <p className="title font-weight-semi-bold">{item.title}</p>
                <p className="subtext">{
                  status === 'failed' ? item.failureText : item.notUploaded}
                </p>
              </div>
              </>
            ) : (status === 'failed') ? (
              <>
              <img
                src={process.env.REACT_APP_IMAGES_PATH + "failure.webp"}
                className="success-img"
                alt="failure img"
              />
              <div className="ml-4">
                <p className="title font-weight-semi-bold">{item.title}</p>
                <p className="subtext">{
                  status === 'failed' ? item.failureText : item.notUploaded}
                </p>
              </div>
              </>
            ) : (
              <>
              <img
                src={process.env.REACT_APP_IMAGES_PATH + "success.webp"}
                className="success-img"
                alt="pending img"
              />
              <div className="ml-4">
                <p className="title font-weight-semi-bold">{item.title}</p>
                <p className="subtext">{item.pendingText}</p>
              </div>
              </>
            )}
          </div>
          <div className="menu">
            <Button onClick={redirectToDocvault}>
              {!isKycDone ? 'Update' : 'Preview'}
            </Button>
          </div>
        </Col>
      );      
    });
  }

  const backBtnAction = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ action: "GO_BACK", data: "dashboard" })
      );
    } else {
      history.replace('/biddeasy-dashboard');
    }
  }

  return (
    <Page className={isNativeView ? "bond-profile pt-0 pb-0" : "bond-profile"}>
      <Sidebar
        className="pl-4 p-4 bg-secondary text-white"
        md="4"
        justify="justify-content-center mt-12"
      >
        <p className="back-btn">
          <span 
            onClick={backBtnAction}
            className="mdi mdi-arrow-left"
          />
        </p>
        <div className="page-title">
          Profile
        </div>
      </Sidebar>
      <Col lg={8} className="main-fold justify-content-center">
        <div className="sub-fold">
        {isMobile && !isNativeView &&
            <div>
              <p className="back-btn text-secondary">
                <span 
                  onClick={backBtnAction}
                  className="mdi mdi-arrow-left"
                />
              </p>
            </div>}
          {!isNativeView && <div className="head-icon">
          <p className="main-title">My Profile</p>
          </div>}
          <Row>
            <Col lg={6} className={!isMobile ? "mb-5" : "mb-3"}>
              <p className="title text-disabled">Name</p>
              <p className="subtext font-weight-semi-bold">
                {thirdPartyData.name ? thirdPartyData.name : "-"}
              </p>
            </Col>
            <Col lg={6} className={!isMobile ? "mb-5" : "mb-3"}>
              <p className="title">Email</p>
              <p className="subtext font-weight-semi-bold">
                {thirdPartyData.email ? thirdPartyData.email : "-"}
              </p>
            </Col>
            <Col lg={6} className={!isMobile ? "mb-5" : "mb-3"}>
              <p className="title">PAN</p>
              <p className="subtext font-weight-semi-bold">
                {thirdPartyData.pan ? thirdPartyData.pan : "-"}
              </p>
            </Col>
            <Col lg={6} className={!isMobile ? "mb-5" : "mb-3"}>
              <p className="title">Mobile number</p>
              <p className="subtext font-weight-semi-bold">
                {userDetails.phone ? userDetails.phone : "-"}
              </p>
            </Col>
          </Row>
        </div>
        <div className="new-fold">
          <div className="new-sub-fold">
            <p className="main-title">My Documents</p>
            <div className="card-wrapper">
              {errors && getDocsStateCard()}
            </div>
          </div>
        </div>
        {/* <button onClick={hypervergeVerification}>
            Hyperverge Verification
          </button> */}
      </Col>

      {isPreviewOpen ?
        <PreviewModal 
          close={closePreview}
          isOpen={isPreviewOpen}
          preview={previewData}
          isPdf={isPdf}
        />
      : null }
      {isAddress ?
        <AddressPreview 
        isOpen={isAddress}
        toggle={toggleAddress}
        address={addressFiles}
      /> : null}
      <ToastContainer />
    </Page>
  );
}
